module.exports = __webpack_public_path__ + "img/arrears-peopel-total-number.dc1eff40.svg";